import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";
import { Link } from "@/i18n/navigation";
import { ComponentProps, ReactNode } from "react";

type MenuProps = Omit<ComponentProps<typeof Link>, "content"> & {
  linkTitle: string;
  trigger: string;
  content: string | ReactNode | ReactNode[];
};

const Menu = ({ ...props }: MenuProps) => {
  return (
    <>
      <NavigationMenu>
        <NavigationMenuList>
          <NavigationMenuItem>
            {props.trigger && (
              <NavigationMenuTrigger>{props.trigger}</NavigationMenuTrigger>
            )}
            {props.content && (
              <NavigationMenuContent>{props.content}</NavigationMenuContent>
            )}
            {props.href && (
              <Link
                className="hover:text-primary text-ring font-medium transition-[color]"
                href={props.href}
              >
                {props.linkTitle}
              </Link>
            )}
          </NavigationMenuItem>
        </NavigationMenuList>
      </NavigationMenu>
    </>
  );
};

export default Menu;
